import React, { useEffect, useState } from "react";
import { KiinteistoRiskReport } from "./10vRiskReportUI.jsx";
import { DEFAULT_RISK_ROWS } from "./kiinteistoRiskReportBlock.jsx";

const createRows = (rows = []) =>
  rows.map((name) => ({
    name,
    risk: "",
    extra: false,
    notes: "",
  }));

const createSingleSection = (title, rows) => [
  {
    title,
    rows: createRows(rows),
  },
];

function createRiskSystemBlock(title, defaultRows) {
  return function RiskSystemBlock({ data = {}, onChange }) {
    const [localSections, setLocalSections] = useState(data?.sections || []);

    useEffect(() => {
      if (!data?.sections || data.sections.length === 0) {
        const initialSections = createSingleSection(title, defaultRows);
        setLocalSections(initialSections);
        onChange({ ...data, sections: initialSections });
      } else {
        setLocalSections(data.sections);
      }
    }, [data?.sections]);

    const saveSections = (newSections) => {
      setLocalSections(newSections);
      onChange({
        ...data,
        sections: newSections,
      });
    };

    const updateRow = (sectionIndex, rowIndex, patch) => {
      const newSections = structuredClone(localSections);

      newSections[sectionIndex].rows[rowIndex] = {
        ...newSections[sectionIndex].rows[rowIndex],
        ...patch,
      };

      saveSections(newSections);
    };

    const addRow = (sectionIndex) => {
      const newSections = structuredClone(localSections);

      newSections[sectionIndex].rows.push({
        name: "Uusi kohde",
        risk: "",
        extra: false,
        notes: "",
      });

      saveSections(newSections);
    };

    const deleteRow = (sectionIndex, rowIndex) => {
      const newSections = structuredClone(localSections);
      newSections[sectionIndex].rows.splice(rowIndex, 1);

      saveSections(newSections);
    };

    if (!localSections.length) return null;

    return (
      <KiinteistoRiskReport
        sections={localSections}
        onRowChange={updateRow}
        onAddRow={addRow}
        onDeleteRow={deleteRow}
        editable
      />
    );
  };
}

export const RiskBlockRakenne = createRiskSystemBlock(
  "Rakennetekniikka",
  DEFAULT_RISK_ROWS.rakennetekniikka
);

export const RiskBlockSahko = createRiskSystemBlock(
  "Sähköjärjestelmät",
  DEFAULT_RISK_ROWS.sähkotejärjestelmät
);

export const RiskBlockLVI = createRiskSystemBlock(
  "LVI Järjestelmät",
  DEFAULT_RISK_ROWS.LVIjärjestelmät
);